(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('PurchaseProducerReportController', PurchaseProducerReportController);

	PurchaseProducerReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function PurchaseProducerReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			loading: true,
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Bottles In Cellar / Purchased / On Order',
							'Cost',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						var keyName = 'Producer';
						var keyNamePlural = keyName + 's';

						// add only those that were purchased
						lodash.forEach(wineEntities, function(wine) {
							var purchases = wine.getPurchaseHistory();

							if (purchases.length > 0) {
								self.wines.push(wine);
							}
						});

						var totalWines = self.wines.length;

						// by producer
						var winesGrouped = lodash.groupBy(self.wines, function(w) {
							return (w.producer && w.producer.name) ? lodash.capitalize(w.producer.name.toLowerCase()) : 'Unknown';
						});

						// initialize totals
						var grandTotals = {
							bottlesInCellar: 0,
							value: 0,
							groups: Object.keys(winesGrouped).length,
							wines:  totalWines
						};

						lodash.forEach(winesGrouped, function(wines, group) {
							var groupTotals = {
								bottlesInCellar: 0,
								value: 0
							};

							// totals value for grouping
							groupTotals.bottlesInCellar = WineRepository.getTotalCellarBottleCount(wines);
							groupTotals.value = WineRepository.getCellarValue(wines);

							var formattedWines = [];

							lodash.forEach(wines, function(wine) {
								var varietal = (wine.varietal && wine.varietal.name) ? wine.varietal.name + ' ' : '';
								var category = (wine.category && wine.category.name) ? wine.category.name : '';
								var type = varietal + category;

								// add foreach purchase here.
								var purchases = wine.getPurchaseHistory();

								lodash.forEach(purchases, function(purchase) {
									var purchasePriceFloat = purchase.price;

									var valueGainFormatted = wine.getRelativeGainPercentFormatted(purchasePriceFloat);
									var valueGainClass = wine.getValueGainClass(purchasePriceFloat);

									// data we want to display on a single wine
									formattedWines.push({
										name: wine.getFullName(),
										appelation: wine.getFullAppellation(),
										type: type,
										size: wine.bottleSize.name,
										qtyInCellar: wine.cellar.qty,
										qtyPurchased: purchase.qty,
										qtyOnOrder: wine.getOnOrderQty(),
										purchasePrice: $window.numeral(purchasePriceFloat).format('$0,0[.]00'),
										value: $window.numeral(wine.cellar.value).format('$0,0[.]00'),
										gain: valueGainFormatted,
										gainClass: valueGainClass
									});
								});
							});

							self.report.groups.push({
								group: group,
								bottles: groupTotals.bottlesInCellar,
								value: $window.numeral(groupTotals.value).format('$0,0[.]00'),
								wines: formattedWines
							});

							// update grand total value
							grandTotals.value += groupTotals.value;
							grandTotals.bottlesInCellar += groupTotals.bottlesInCellar;
						});

						self.report.totals = [
							// 'Producer / Wine',
							'Total ' + keyNamePlural + ': ' + grandTotals.groups + '<br/>Total wines: ' + grandTotals.wines,
							// 'Size',
							null,
							// 'Bottles',
							grandTotals.bottlesInCellar,
							// 'Average Cost',
							null,
							// 'Value',
							$window.numeral(grandTotals.value).format('$0,0[.]00'),
							// 'Gain / Loss'
							null
						];

						// hide loading
						self.report.loading = false;

						return true;
					}

					return false;

				}).catch(function(err){
				$log.debug('Error getting wines', err);
			});

		}

		function print(){
			return $window.print();
		}
	}

})();
